import { AnfrageService } from "@/api/service-index";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";
import { StipendiumDisplayModel } from "@/api/model-index";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageStipendiumResolver  {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<StipendiumDisplayModel | undefined> {
      let id: string = <string>route.params['id'];

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.stipendium)
        return of(this.portalContextService.CurrentAnfrage.stipendium).toPromise();
    
      return this.anfrageService.apiAnfrageAnfrageIdStipendiumGet({ anfrageId: id }).pipe(map(response => {        
        if (response) {
          if(!this.portalContextService.CurrentAnfrage?.stipendium) {
            this.portalContextService.CurrentAnfrage.name = response.title;
            this.portalContextService.CurrentAnfrage.stipendium = response;
          }

          if(this.portalContextService.CurrentAnfrage?.stipendium)
            return this.portalContextService.CurrentAnfrage.stipendium;
        }

        return undefined;
      })).toPromise();
    }
  }